document.addEventListener('DOMContentLoaded', function () {
  if (!document.getElementById('affiliate-greeting')) return;

  var params = new URLSearchParams(window.location.search);
  var name = params.get('name') || '';
  var scaRef = params.get('sca_ref') || '';
  var productHandle = params.get('product') || '';

  if (!scaRef) {
    var subtitleEl = document.querySelector('.affiliate-subtitle');
    if (subtitleEl) subtitleEl.style.display = 'none';
    document.getElementById('affiliate-no-params').style.display = 'block';
    document.getElementById('affiliate-page-content').style.display = 'none';
    var infoEl = document.getElementById('affiliate-info');
    if (infoEl) infoEl.style.display = 'none';
    return;
  }

  var greetingEl = document.getElementById('affiliate-greeting');
  var imageEl = document.getElementById('affiliate-product-image');
  var fallbackEl = document.getElementById('affiliate-fallback-image');
  var productNameEl = document.getElementById('affiliate-product-name');
  var captionEl = document.getElementById('affiliate-caption');
  var mobileShareSection = document.getElementById('affiliate-mobile-share');
  var desktopSection = document.getElementById('affiliate-platforms');
  var mobileCaptionEl = document.getElementById('affiliate-mobile-caption');
  var pickerEl = document.getElementById('affiliate-picker');

  var hasRef = scaRef && scaRef.length > 0;
  var refParam = hasRef ? '?snowball=' + encodeURIComponent(scaRef) : '';
  var linkUrl = 'https://keelanscott.co' + refParam;
  var imageBlob = null;
  var imageFileName = 'keelan-scott.jpg';
  var captionText = '';
  var captionTextNoTag = '';
  var productImageUrl = '';
  var selectionToken = 0;

  if (name) {
    var subEl = document.querySelector('.affiliate-subtitle');
    if (subEl) {
      subEl.textContent = productHandle
        ? 'Thanks for your order, ' + name + '!'
        : 'Thanks for joining, ' + name + '!';
    }
  }

  function buildCaption(productTitle) {
    var title = productTitle || 'furniture';
    return 'Loving my new ' + title + ' from @keelanscottco \u{1F525} My link gives you 5% off for the next 30 days: ' + linkUrl;
  }

  function buildCaptionNoTag(productTitle) {
    var title = productTitle || 'furniture';
    return 'Loving my new ' + title + ' \u{1F525} My link gives you 5% off for the next 30 days: ' + linkUrl;
  }

  function setCaption(text, textNoTag) {
    captionText = text;
    captionTextNoTag = textNoTag;
    captionEl.textContent = text;
    mobileCaptionEl.textContent = text;
  }

  function setProductName(title) {
    if (title && productNameEl) {
      productNameEl.textContent = title;
      productNameEl.style.display = 'block';
    }
  }

  function fetchImageBlob(url) {
    var sizedUrl = url.split('?')[0] + '?width=1080';
    return fetch(sizedUrl).then(function (r) { return r.blob(); });
  }

  function isMobile() {
    return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  }

  function copyCaption(el, btn) {
    var temp = document.createElement('span');
    temp.textContent = el.textContent;
    temp.style.position = 'absolute';
    temp.style.left = '-9999px';
    document.body.appendChild(temp);
    var range = document.createRange();
    range.selectNodeContents(temp);
    var sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);
    document.execCommand('copy');
    sel.removeAllRanges();
    document.body.removeChild(temp);
    btn.innerHTML = '&#10003; Copied!';
  }

  // Mobile: share with image + text + url
  function handleMobileShare() {
    var shareData = { text: captionText, url: linkUrl };
    if (imageBlob) {
      var file = new File([imageBlob], imageFileName, { type: imageBlob.type });
      shareData.files = [file];
      if (navigator.canShare && !navigator.canShare(shareData)) {
        delete shareData.files;
      }
    }
    navigator.share(shareData).catch(function () {});
  }

  function copyLink(btn) {
    var temp = document.createElement('span');
    temp.textContent = linkUrl;
    temp.style.position = 'absolute';
    temp.style.left = '-9999px';
    document.body.appendChild(temp);
    var range = document.createRange();
    range.selectNodeContents(temp);
    var sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);
    document.execCommand('copy');
    sel.removeAllRanges();
    document.body.removeChild(temp);
    btn.innerHTML = '&#10003; Copied!';
  }

  // Mobile: platform grid selection
  function selectPlatform(platform) {
    var gridBtns = document.querySelectorAll('.affiliate-mobile-grid-btn');
    var stepsSections = document.querySelectorAll('.affiliate-mobile-steps');
    gridBtns.forEach(function (btn) {
      btn.classList.toggle('active', btn.getAttribute('data-platform') === platform);
    });
    stepsSections.forEach(function (section) {
      section.classList.remove('active');
    });
    var target = document.getElementById('affiliate-steps-' + platform);
    if (target) target.classList.add('active');
  }

  // Keeps every share target pointed at the current selection. Never touches
  // display state, so it is safe to call while the Facebook step is open.
  function refreshShareTargets() {
    var xEl = document.getElementById('affiliate-share-x');
    if (xEl) xEl.href = 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(captionTextNoTag);
    var fbCaptionEl = document.getElementById('affiliate-fb-caption');
    if (fbCaptionEl && fbCaptionEl.textContent) fbCaptionEl.textContent = captionText;
  }

  // Desktop: Pinterest
  function handlePinterest() {
    var encodedUrl = encodeURIComponent(linkUrl);
    var encodedText = encodeURIComponent(captionTextNoTag);
    var pinUrl = 'https://pinterest.com/pin/create/button/?url=' + encodedUrl + '&description=' + encodedText;
    if (productImageUrl) pinUrl += '&media=' + encodeURIComponent(productImageUrl);
    window.open(pinUrl, '_blank');
  }

  // Desktop: Facebook step view
  function handleFacebook() {
    var fbStep = document.getElementById('affiliate-fb-step');
    var fbCaption = document.getElementById('affiliate-fb-caption');
    fbCaption.textContent = captionText;
    desktopSection.style.display = 'none';
    fbStep.style.display = '';
  }

  function handleFbCopy() {
    copyCaption(document.getElementById('affiliate-fb-caption'), document.getElementById('affiliate-fb-copy'));
  }

  function handleFbContinue() {
    var encodedUrl = encodeURIComponent(linkUrl);
    var fbUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + encodedUrl;
    window.open(fbUrl, '_blank');
  }

  function handleFbBack() {
    var fbStep = document.getElementById('affiliate-fb-step');
    desktopSection.style.display = '';
    fbStep.style.display = 'none';
  }

  function setHeroImage(src, alt) {
    if (!src) return;
    productImageUrl = src.split('?')[0] + '?width=1080';
    imageEl.alt = alt || '';
    imageEl.onload = function () {
      imageEl.style.display = '';
      if (fallbackEl) fallbackEl.style.display = 'none';
    };
    imageEl.src = src.split('?')[0] + '?width=800';
  }

  // The one place a selection is applied. Everything downstream (caption, link,
  // hero image, share targets, native-share blob) reads from here.
  function selectProduct(handle, title, imageSrc, autoScroll) {
    var token = ++selectionToken;
    linkUrl = (handle ? 'https://keelanscott.co/products/' + encodeURIComponent(handle) : 'https://keelanscott.co') + refParam;
    setCaption(buildCaption(title), buildCaptionNoTag(title));
    setProductName(title);
    setHeroImage(imageSrc, title);
    refreshShareTargets();

    var selectedEl = null;
    thumbEls.forEach(function (t) {
      var isSelected = t.getAttribute('data-handle') === handle;
      t.classList.toggle('selected', isSelected);
      if (isSelected) selectedEl = t;
    });

    // Only centre on the initial selection. Doing it on a click would yank the
    // row out from under the thumbnail the person just tapped.
    if (autoScroll) {
      var row = pickerEl ? pickerEl.querySelector('.affiliate-thumbs') : null;
      if (row && selectedEl) {
        row.scrollLeft = selectedEl.offsetLeft - (row.clientWidth - selectedEl.clientWidth) / 2;
      }
    }

    imageBlob = null;
    if (imageSrc) {
      fetchImageBlob(imageSrc).then(function (blob) {
        if (token !== selectionToken) return;
        imageBlob = blob;
        imageFileName = 'keelan-scott-purchase' + (blob.type === 'image/png' ? '.png' : '.jpg');
      }).catch(function () {});
    }
  }

  function updateUI() {
    var mobile = isMobile() && navigator.share;
    mobileShareSection.style.display = mobile ? 'block' : 'none';
    desktopSection.style.display = mobile ? 'none' : '';
    refreshShareTargets();
  }

  // Wire up mobile grid
  document.querySelectorAll('.affiliate-mobile-grid-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      selectPlatform(btn.getAttribute('data-platform'));
    });
  });

  // Mobile share buttons (one per platform step)
  ['fb', 'x', 'ig', 'pin'].forEach(function (p) {
    var shareBtn = document.getElementById('affiliate-mob-share-' + p);
    if (shareBtn) shareBtn.addEventListener('click', handleMobileShare);
  });

  // Mobile copy caption (FB)
  var mobCopyCaptionFb = document.getElementById('affiliate-mob-copy-caption-fb');
  if (mobCopyCaptionFb) {
    mobCopyCaptionFb.addEventListener('click', function () {
      copyCaption(mobileCaptionEl, mobCopyCaptionFb);
    });
  }

  // Mobile copy link (IG)
  var mobCopyLinkIg = document.getElementById('affiliate-mob-copy-link-ig');
  if (mobCopyLinkIg) {
    mobCopyLinkIg.addEventListener('click', function () {
      copyLink(mobCopyLinkIg);
    });
  }

  // Wire up desktop events
  document.getElementById('affiliate-share-pin').addEventListener('click', handlePinterest);
  document.getElementById('affiliate-share-fb').addEventListener('click', handleFacebook);
  document.getElementById('affiliate-fb-copy').addEventListener('click', handleFbCopy);
  document.getElementById('affiliate-fb-continue').addEventListener('click', handleFbContinue);
  document.getElementById('affiliate-fb-back').addEventListener('click', handleFbBack);

  // Product picker
  var thumbEls = Array.prototype.slice.call(document.querySelectorAll('.affiliate-thumb'));

  function wireThumb(el) {
    el.addEventListener('click', function () {
      selectProduct(el.getAttribute('data-handle'), el.getAttribute('data-title'), el.getAttribute('data-image'));
    });
  }

  thumbEls.forEach(wireThumb);

  function findThumb(handle) {
    for (var i = 0; i < thumbEls.length; i++) {
      if (thumbEls[i].getAttribute('data-handle') === handle) return thumbEls[i];
    }
    return null;
  }

  function selectDefault() {
    var def = null;
    if (pickerEl) {
      var configured = pickerEl.getAttribute('data-default-handle');
      if (configured) def = findThumb(configured);
    }
    if (!def && thumbEls.length) def = thumbEls[0];
    if (def) {
      selectProduct(def.getAttribute('data-handle'), def.getAttribute('data-title'), def.getAttribute('data-image'), true);
    } else {
      setCaption(buildCaption(null), buildCaptionNoTag(null));
      refreshShareTargets();
    }
  }

  updateUI();

  var matched = productHandle ? findThumb(productHandle) : null;

  if (matched) {
    selectProduct(productHandle, matched.getAttribute('data-title'), matched.getAttribute('data-image'), true);
  } else if (productHandle) {
    // Their product is not in the picker (an add-on, or excluded). Fetch it,
    // put it at the front of the row, and select it so they still see theirs.
    fetch('/products/' + encodeURIComponent(productHandle) + '.json')
      .then(function (r) {
        if (!r.ok) throw new Error('not found');
        return r.json();
      })
      .then(function (data) {
        var product = data.product;
        var img = product.images && product.images[0] ? product.images[0].src : '';
        var row = pickerEl ? pickerEl.querySelector('.affiliate-thumbs') : null;
        if (row && img) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'affiliate-thumb';
          btn.setAttribute('data-handle', product.handle);
          btn.setAttribute('data-title', product.title);
          btn.setAttribute('data-image', img);
          var thumbImg = document.createElement('img');
          thumbImg.src = img.split('?')[0] + '?width=200';
          thumbImg.alt = product.title;
          var label = document.createElement('span');
          label.textContent = product.title;
          btn.appendChild(thumbImg);
          btn.appendChild(label);
          row.insertBefore(btn, row.firstChild);
          thumbEls.unshift(btn);
          wireThumb(btn);
        }
        selectProduct(product.handle, product.title, img, true);
      })
      .catch(function () {
        selectDefault();
      });
  } else {
    selectDefault();
  }
});
